import DataTypeService from '@/services/DataTypeService';

const initialState = {
	dataTypes: []
};

export default {
	namespaced: true,

	//#region [ State ]
	state: {
		...initialState
	},
	//#endregion

	//#region [ Mutations ]
	mutations: {
		setDataTypes(state, payload) {
			state.dataTypes = payload;
		},
		reset(state) {
			Object.assign(state, initialState);
		}
	},
	//#endregion

	//#region [ Actions ]
	actions: {
		async getDataTypes({ commit }, type) {
			try {
				const res = await DataTypeService.getDataTypesAsync(type);
				if (res.status === 200) {
					commit('setDataTypes', res.data.Data);
				}
				return res.data;
			} catch (error) {
				console.log(error);
			}
		},

		resetState({ commit }) {
			commit('reset');
		},

		// eslint-disable-next-line no-unused-vars
		async saveDataType({ commit }, dataType) {
			try {
				let response = await DataTypeService.saveDataType(dataType);
				return response;
			} catch (error) {
				console.log(error);
			}
		},

		// eslint-disable-next-line no-unused-vars
		async getDataTypeById({ commit }, id) {
			try {
				let response = await DataTypeService.getDataTypeById(id);
				return response;
			} catch (error) {
				console.log(error);
			}
		},

		// eslint-disable-next-line no-unused-vars
		async updateDataType({ commit }, { id, dataType }) {
			try {
				let response = await DataTypeService.updateDataType(id, dataType);
				return response;
			} catch (error) {
				console.log(error);
			}
		},

		// eslint-disable-next-line no-unused-vars
		async deleteDataType({ commit }, id) {
			try {
				let response = await DataTypeService.deleteDataType(id);
				return response;
			} catch (error) {
				console.log(error);
			}
		},
		// eslint-disable-next-line no-unused-vars
		async canEditOrDelete({ commit }, id) {
			try {
				let response = await DataTypeService.canEditOrDelete(id);
				return response;
			} catch (error) {
				console.log(error);
			}
		}
	},
	//#endregion

	//#region [ Getters ]
	getters: {}
	//#endregion
};
